module.exports = __webpack_public_path__ + "static/media/Triangle.2f5ffa86.svg";